var styleDataHash = "d81698d7";
const injectCss = () => {
  var css = `@charset "UTF-8";.ReactModalPortal,.glob_fontElementMap,.nJmtA,.zpf8B,button{font-family:var(--ricos-font-family,unset)}.sdp4c{display:flex}[dir] ._1H6Qf:hover{box-shadow:0 0 0 2px var(--ricos-focus-action-color,var(--ricos-action-color,#116dff))}[dir] .V8s7g,[dir] ._1H6Qf:hover{border-radius:var(--ricos-native-whitebox-border-radius,0);cursor:default}[dir] .V8s7g{box-shadow:0 0 0 1px var(--ricos-focus-action-color,var(--ricos-action-color,#116dff))}[dir] .lfOx2 .V8s7g{box-shadow:none!important}.hPvdS{display:block;height:100%;position:absolute;top:0;width:100%}[dir] .hPvdS{cursor:move}[dir=ltr] .hPvdS{left:0}[dir=rtl] .hPvdS{right:0}.hPvdS._5iAIp{pointer-events:none}[dir] .zYXe0 ::selection{background:transparent}.M0hf4{display:none}.nJmtA{position:relative}._2dOH2{max-width:100%}.ReactModal__Body--open{overflow-y:hidden}.ReactModal__Content{font-weight:300}[dir=ltr] .ReactModal__Content{direction:ltr}[dir=rtl] .ReactModal__Content{direction:rtl}.ReactModalPortal{color:var(--ricos-settings-text-color,#333)}.ReactModalPortal,.ReactModalPortal input{font-family:var(--ricos-settings-text-font-family,Madefor,"Helvetica Neue",Helvetica,Arial,メイリオ,meiryo,"ヒラギノ角ゴ pro w3","hiragino kaku gothic pro",sans-serif)}.Hcu9y{color:#333;text-decoration:none}._2ljR-{display:block}.XRUSL{position:relative}.BJZRy{overflow-x:auto;overflow-y:hidden}[dir=ltr] .BJZRy,[dir=rtl] .BJZRy{margin-left:-20px;margin-right:-20px}[dir] .BJZRy.T5chD::-webkit-scrollbar-thumb{background-color:rgba(0,0,0,.5)}[dir] .BJZRy._0YdSL::-webkit-scrollbar-thumb{background-color:transparent}.RhgKn{max-width:max-content!important;min-width:100%}.BJZRy::-webkit-scrollbar{-webkit-appearance:none}[dir] .BJZRy::-webkit-scrollbar-thumb{border:2px solid #fff;border-radius:8px}.BJZRy::-webkit-scrollbar:horizontal{height:10px}`;
  var isTest = typeof process !== "undefined" && process.env && false;
  if (isTest || !css || typeof document === "undefined") {
    return;
  }
  if (document.querySelector('style[data-ricos-style-hash="' + styleDataHash + '"]')) {
    return;
  }
  var head = document.head || document.getElementsByTagName("head")[0];
  var style = document.createElement("style");
  style.setAttribute("data-ricos-style-hash", styleDataHash);
  style.type = "text/css";
  head.appendChild(style);
  if (style.styleSheet) {
    style.styleSheet.cssText = css;
  } else {
    style.appendChild(document.createTextNode(css));
  }
};
injectCss();
var general_default = {
  "fontElementMap": "zpf8B",
  "pluginContainer": "nJmtA",
  "flex": "sdp4c",
  "isFocusable": "_1H6Qf",
  "hasFocus": "V8s7g",
  "dragImageView": "lfOx2",
  "overlay": "hPvdS",
  "noPointerEventsOnFocus": "_5iAIp",
  "hideTextSelection": "zYXe0",
  "hidden": "M0hf4",
  "pluginContainerMobile": "_2dOH2",
  "isImage": "Hcu9y",
  "anchor": "_2ljR-",
  "horizontalScrollbarWrapper": "XRUSL",
  "pluginWithHorizontalScrollbar": "BJZRy",
  "show": "T5chD",
  "hide": "_0YdSL",
  "horizontalScrollbar": "RhgKn"
};
export {
  general_default as default,
  injectCss
};
//# sourceMappingURL=general-scss.js.map
